import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	previewMessageContent: {
		width: "100%",
		maxHeight: 500,
		padding: 4,
		overflowY: "auto",
		borderRadius: 8,
		"&::-webkit-scrollbar": {
			width: "0.25em"
		},
		"&::-webkit-scrollbar-track": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[300]),
			borderRadius: "0px 8px 8px 8px"
		},
		"&::-webkit-scrollbar-thumb": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[400]),
			borderRadius: 8,
			border: "2px solid transparent"
		}
	},
	messagePreview: {
		padding: 10,
		flexDirection: "column",
		justifyContent: "end",
		borderRadius: 8,
		position: "sticky"
	},
	container: {
		alignItems: "flex-end"
	},
	menuItemTooltipWrapper: {
		display: "block",
		width: "100%"
	},
	disabledMenuItemTooltipWrapper: {
		display: "block",
		width: "100%",
		pointerEvents: "auto"
	}
})

export default useStyles
